var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 88,
    viewBox: "0 0 79 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8037 77.1671C39.8037 77.1671 40.2546 64.7666 39.8037 60.3701C39.3528 55.9736 38 52.5916 38 50.4497C38 48.3078 38 45.8277 38 41.7694C38 37.711 39.9724 31.7363 40.0039 30.0453C39.9552 29.3202 39.8037 27.6779 40.0039 26.8888C40.2826 25.793 41.7201 24.6342 41.7201 22.9432C41.7201 21.2522 41.1565 17.8703 43.4111 15.9538C45.6658 14.0374 46.0039 14.2628 46.5676 12.4591C47.1313 10.6554 48.935 10.43 49.8368 9.97904C50.7387 9.52812 53.4442 7.61168 54.9097 6.2589C56.3753 4.90612 58.9681 3.66607 61.6736 3.10241C64.3792 2.53876 65.6193 1.74963 67.0848 1.52417C68.5503 1.29871 73.285 -0.279536 73.285 3.44061C73.285 7.16075 70.4667 7.83714 68.0993 8.739C65.732 9.64085 62.6882 10.9936 61.7864 11.5573C60.8845 12.1209 60.0954 13.9247 57.3898 14.7138",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2876 21.9285C50.2876 21.9285 51.6765 23.0828 52.204 23.2812C53.0292 23.5906 53.6695 23.7322 56.1496 23.9576C58.6297 24.1831 63.9281 24.634 64.3791 27.1141C64.83 29.5942 64.4918 31.0597 63.2517 32.9762C62.0117 34.8926 60.9971 34.6671 60.9971 34.6671",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.042 13.9949V15.6904",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0562 20.2216C68.0562 20.2216 68.8877 19.4487 71.0296 18.4341C73.1715 17.4195 76.9782 16.6683 77.6546 19.4866C78.331 22.3048 77.1171 23.3943 73.9606 25.7617C70.8041 28.129 69.8779 27.624 68.8877 27.3399",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8775 27.6238C69.8775 27.6238 67.9854 30.4962 66.8581 31.7362C65.7308 32.9763 62.7231 39.8529 59.0417 41.2057C59.0417 41.2057 58.1435 41.6566 57.4283 42.7839C56.7131 43.9112 54.9094 46.0531 54.3458 47.0677C53.7821 48.0823 54.0076 52.7043 54.3458 56.7627C54.684 60.821 55.1277 65.5963 56.1495 69.0504C57.7512 74.4651 58.5529 77.5053 59.0426 81",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2295 29.5945C46.2295 29.5945 49.4987 31.2855 52.4297 31.9618C55.3608 32.6382 62.6883 32.6382 60.6591 37.8239C58.63 43.0095 50.0624 39.6673 48.4841 39.0838",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7669 40.1362C51.7669 40.1362 50.9642 45.0387 46.2295 46.3915",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2876 13.3608C50.2876 13.3608 52.204 14.9391 55.6419 15.5027C59.0807 16.0664 62.9135 16.1791 65.3936 16.8555C65.3936 16.8555 68.6629 17.3443 67.761 23.2064C66.8592 29.0684 65.2331 29.5193 64.5432 29.5942",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4062 71.4062C35.3516 72.6693 33.8607 73.6523 31.9336 74.3555C30.0065 75.0456 27.8711 75.3906 25.5273 75.3906C23.0664 75.3906 20.9049 74.8568 19.043 73.7891C17.194 72.7083 15.7617 71.1458 14.7461 69.1016C13.7435 67.0573 13.2292 64.6549 13.2031 61.8945V59.9609C13.2031 57.1224 13.6784 54.668 14.6289 52.5977C15.5924 50.5143 16.9727 48.9258 18.7695 47.832C20.5794 46.7253 22.6953 46.1719 25.1172 46.1719C28.4896 46.1719 31.1263 46.9792 33.0273 48.5938C34.9284 50.1953 36.0547 52.5326 36.4062 55.6055H30.7031C30.4427 53.9779 29.8633 52.7865 28.9648 52.0312C28.0794 51.276 26.8555 50.8984 25.293 50.8984C23.3008 50.8984 21.7839 51.6471 20.7422 53.1445C19.7005 54.6419 19.1732 56.8685 19.1602 59.8242V61.6406C19.1602 64.6224 19.7266 66.875 20.8594 68.3984C21.9922 69.9219 23.6523 70.6836 25.8398 70.6836C28.0404 70.6836 29.6094 70.2148 30.5469 69.2773V64.375H25.2148V60.0586H36.4062V71.4062Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 63.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhand);
export default __webpack_public_path__ + "static/media/Ghand.e990f86524fac30958632b8e5ea953dc.svg";
export { ForwardRef as ReactComponent };